<template>
  <div class="qualityCheck">
    <div class="specifications">
      <TitleModel title="质检信息" />
      <Sheet :tableData="tableData" :QualityCertificate="QualityCertificate" :num="1">
        <template slot="title">参数</template>
      </Sheet>
    </div>
    <div class="bookPic">
      <TitleModel title="鉴定证书" />
      <template v-if="QualityCertificateImg && QualityCertificateImg.length > 0">
        <div class="imgContainer" v-for="(item, index) in QualityCertificateImg" :key="index">
          <img :src="item" alt="" />
        </div>
      </template>
      <template v-else>
        <div class="imgContainer" v-if="QualityCertificate.certificateUrl">
          <div id="QRCode" class="QRCode"></div>
          <div class="hintTxt">扫码查看货品鉴定证书</div>
        </div>
      </template>
      <div class="pd24">
        <div class="code">
          <div>鉴定证书编号</div>
          <div>{{ certificateSn }}</div>
        </div>
        <div class="link" v-if="QualityCertificate.qualityOrganizationOfficialWebsite">
          <div>
            质检机构官方链接
          </div>
          <div>
            <a :href="QualityCertificate.qualityOrganizationOfficialWebsite">
              {{ QualityCertificate.qualityOrganizationOfficialWebsite }}
            </a>
          </div>
        </div>
        <div class="link" v-if="QualityCertificate.certificateUrl">
          <div>
            质检证书官方链接
          </div>
          <div>
            <span>点击此处查询</span>
            <a :href="QualityCertificate.certificateUrl">{{ QualityCertificate.certificateUrl }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Sheet from "@/components/sheet";
import TitleModel from "../TitleModel.vue";
export default {
  props: {
    QualityCertificate: {
      type: Object,
      default: () => { },
    },
    QualityCertificateImg: {
      type: Array,
      default: () => [],
    },
    barCode: {
      type: String,
      default: () => "",
    },
    certificateSn: {
      type: String,
      default: () => "",
    },
  },
  components: { Sheet, TitleModel },
  data() {
    return {
      tableData: [
        { label: "鉴定证书编号", value: this.QualityCertificate.certificateSn },
        { label: "参数" },
        { label: "品名", value: this.QualityCertificate.name },
        { label: "材质", value: this.QualityCertificate.material },
        { label: "克重", value: `${this.QualityCertificate.qualityWeight || this.QualityCertificate.weight}g` },
        { label: "工艺", value: this.QualityCertificate.workanship },
        {
          label: "质检机构",
          value: this.QualityCertificate.qualityOrganization,
        },
        {
          label: "机构地址",
          value: this.QualityCertificate.qualityOrganizationAddress,
        },
        {
          label: "机构电话",
          value: this.QualityCertificate.qualityOrganizationPhone,
        },
        { label: "鉴定师", value: this.QualityCertificate.qualityPerson },
        { label: "日期", value: this.QualityCertificate.qualityDate },
      ],
    };
  },

  mounted() {
    if (this.QualityCertificate.certificateUrl) this.creatQRCode(this.QualityCertificate.certificateUrl)
  },

  methods: {
    // 生成二维码
    creatQRCode(data) {
      const qrcodeDiv = document.getElementById('QRCode');
      if (!qrcodeDiv) return;
      new QRCode(qrcodeDiv, {
        text: data,
        width: 160,
        height: 160,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.qualityCheck {
  margin: 24px auto 0;

  .quantityPic {
    display: block;
    height: 45px;
    margin: 24px auto;
  }
}

.specifications {
  box-sizing: border-box;
  padding: 0 24px 24px;
  background: #fff;
  height: 1024px;

  .title {
    color: #000000;
    font-size: 28px;
  }
}

.bookPic {
  box-sizing: border-box;
  margin-top: 24px;
  background: rgba(255, 255, 255, 1);

  .title {
    color: rgba(0, 0, 0, 0.9);
    font-size: 28px;
    font-weight: bold;
  }

  .imgContainer {
    padding: 32px;
    margin-top: 24px;

    img {
      display: block;
      width: 95%;
      height: 95%;
      margin: 0 auto;
    }

    .QRCode {
      width: 320px;
      height: 320px;
      margin: 0 auto 24px;
    }

    .hintTxt {
      text-align: center;
      font-weight: 400;
      font-size: 28px;
      color: #999999;
      line-height: 36px;
    }
  }

  .pd24 {
    padding: 0 24px 24px;
  }

  .code {
    width: 80%;
    height: 88px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    div:nth-child(1) {
      width: 100%;
      height: 37px;
      color: rgba(0, 0, 0, 0.6);
      font-size: 26px;
    }

    div:nth-child(2) {
      width: 100%;
      height: 37px;
      color: rgba(0, 0, 0, 0.9);
      font-size: 26px;
      font-weight: bold;
    }
  }

  .link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 85px;
    margin-top: 15px;

    div:nth-child(1) {
      height: 40px;
      color: #666666;
      font-size: 28px;
    }

    div:nth-child(2) {
      height: 37px;
      color: rgba(0, 82, 217, 1);
      font-size: 26px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      a {
        color: rgba(0, 82, 217, 1);
      }
    }
  }
}
</style>
